/**
 * @file localstorage相关信息处理函数
 * @author iknow
 */
/* global App, getApp, Page, Component, Behavior, swan, getCurrentPages, requireDynamicLib */

/**
 * 获取当前本地存储中的赞同数据
 *
 * @return {string | boolean} 缓存中的数据
 */

export let getEvaluteData = () => {
  // 存储的value格式为 replyid（评论点赞）
  if (!getApp().$api.getStorageSync('IKNOW_EVALUATE_LOCAL')) {
    return false;
  }
  return getApp().$api.getStorageSync('IKNOW_EVALUATE_LOCAL');
};
// 判断本地存储中是否有当前的数据
export let hasEvaluted = currentData => {
  currentData = '' + currentData;
  if (!getEvaluteData()) {
    return false;
  }
  if (getEvaluteData().split(',').indexOf(currentData) >= 0) {
    return true;
  }
  return false;
};

/**
 * 将点赞信息存储到本地本地存储中
 *
 * @param {string | number} currentData 当前点赞信息
 * @param {number} like 是点赞还是取消点赞
 */

export let setEvaluteData = (currentData, like) => {
  currentData = '' + currentData;
  const evaluateData = getEvaluteData();
  if (like && typeof evaluateData === 'string' && evaluateData.indexOf(currentData) > -1) {
    getApp().$api.setStorageSync('IKNOW_EVALUATE_LOCAL', evaluateData.replace(currentData, ''));
    return;
  }
  let storeData = !evaluateData ? currentData : evaluateData + ',' + currentData;
  getApp().$api.setStorageSync('IKNOW_EVALUATE_LOCAL', storeData);
};

/**
 * 获取赞踩本地缓存信息--赞踩支持未登录
 *
 * @param {Object} reply 回答信息
 * @return {Object}
 */

export let getSupport = function (reply) {
  let supportStr = getApp().$api.getStorageSync('QUESTION_SUPPORT') + '';
  let unsupportStr = getApp().$api.getStorageSync('QUESTION_UNSUPPORT') + '';
  if (supportStr && supportStr.search(reply.rid) > -1) {
    reply.evaluatedType = 1;
  }
  if (unsupportStr && unsupportStr.search(reply.rid) > -1) {
    reply.evaluatedType = 2;
  }
  return reply;
};

/**
 * 设置赞踩本地缓存信息--赞踩支持未登录
 *
 * @param {Number} rid 回答rid
 * @param {Number} actype 1赞 2踩赞
 * @param {Boolean} isCancel true取消赞踩 false赞踩
 */

export const setSupport = function (rid, actype, isCancel) {
  const recoderKey = actype === 1 ? 'QUESTION_SUPPORT' : 'QUESTION_UNSUPPORT';
  const sRid = rid + '';
  let supportRecorder = getApp().$api.getStorageSync(recoderKey) + '';
  if (supportRecorder) {
    supportRecorder = supportRecorder.replace(',' + sRid, '').replace(sRid + ',', '').replace(sRid, '');
  }
  if (!isCancel) {
    getApp().$api.setStorageSync(recoderKey, !supportRecorder ? sRid : [sRid, supportRecorder].join(','));
  } else {
    getApp().$api.setStorageSync(recoderKey, supportRecorder);
  }
};